<template>
  <v-container
    no-gutters
  >
    <v-row>
      <v-col
        cols="12"
      >
        <WrldCurrentFiltersV2 :wrld="{index: 'Shipments', facetIndex: 'ShipmentsFacets', isResource: false}"
        :translatedFilters="[
        {
          type: 'Status',
          i18nPreffix: 'shipments'
        },
        {
          type: 'Types',
          i18nPreffix: 'shipments'
        }
        ]"
        :notClearable="['DepartureFrom']" />
      </v-col>
      <v-col
        cols="12"
      >
        <WrldDateFilters
          :wrld="{index: 'Shipments', facetIndex: 'ShipmentsFacets'}"
          :dateFilter="{ title: this.$i18n.t('shipments.departure'), attribute: 'DepartureFrom' }"
        />
      </v-col>
      <v-col
        cols="12"
        class="pb-0"
      >
        <WrldShipmentModeFilters :wrld="{index: 'Shipments', facetIndex: 'ShipmentsFacets', pageSize: 20}" :filter="{ attribute: 'Types', title: $t('shipments.mode') }" />
      </v-col>
      <!-- <v-col
        class="py-1"
        cols="12"
      >
        <WrldSelectableFilters :wrld="{index: 'Shipments', facetIndex: 'ShipmentsFacets', pageSize: 20}" :isGenericResource="false" :arrFilters="WrldSelectablearrFilters" />
      </v-col> -->
      <v-col
        class="py-1"
        cols="12"
      >
        <WrldSelectableFiltersV2 :wrld="{index: 'Shipments', facetIndex: 'ShipmentsFacets', pageSize: 20}" :isGenericResource="false" :arrFilters="WrldSelectablearrFilters" />
      </v-col>
      <v-col
        cols="12"
        class="py-1"
      >
        <WrldShipmentsGroupByDayRangeFilters
          :wrld="{ index: 'Shipments', facetIndex: 'ShipmentsFacets' }"
          :rangeFilter="{ title: this.$t('shipments.weight'), attribute: 'Weight' }"
        />
      </v-col>
      <v-col
        cols="12"
        class="py-1"
      >
        <WrldShipmentsGroupByDayRangeFilters
          :wrld="{ index: 'Shipments', facetIndex: 'ShipmentsFacets' }"
          :rangeFilter="{ title: this.$t('shipments.volume'), attribute: 'Volume' }"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import WrldCurrentFilters from '@/components/wrld/filters/WrldCurrentFilters'
import WrldCurrentFiltersV2 from '@/components/wrld/filters/WrldCurrentFiltersV2'
import WrldSelectableFilters from '@/components/wrld/filters/WrldSelectableFilters'
import WrldSelectableFiltersV2 from '@/components/wrld/filters/WrldSelectableFiltersV2'
import WrldDateFilters from '@/components/wrld/filters/WrldDateFilters'
import WrldShipmentModeFilters from '@/components/wrld/filters/WrldShipmentModeFilters'
import WrldShipmentsGroupByDayRangeFilters from '@/components/wrld/filters/WrldShipmentsGroupByDayRangeFilters'

export default {
  name: 'ShipmentsGroupByDayFilters',
  components: {
    WrldSelectableFilters,
    WrldSelectableFiltersV2,
    WrldCurrentFilters,
    WrldCurrentFiltersV2,
    WrldDateFilters,
    WrldShipmentModeFilters,
    WrldShipmentsGroupByDayRangeFilters
  },
  mounted() {
    if (this.getResourceIndex !== 'Shipments') {
      this.setResourceIndex({ index: 'Shipments' })
    }
  },
  methods: {
    ...mapActions({
      setResourceIndex: 'setResourceIndex'
    })
  },
  computed: {
    ...mapGetters({
      getRangesByType: 'shipmentsGroupByDay/getRangesByType',
      getResourceIndex: 'getResourceIndex'
    }),
    WrldSelectablearrFilters () {
      return [
        // { title: this.$t('shipments.mode'), attribute: '__typename', isSearchable: false },
        { title: this.$t('companies.labels'), attribute: 'Labels' },
        { title: this.$t('shipments.status'), attribute: 'Status' },
        // { title: this.$t('shipments.weight'), attribute: 'weight'},
        // { title: this.$t('shipments.volume'), attribute: 'volume'}
      ]
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
